import Konsole from "./konsole/Konsole";
export const GetTotalPrice = (data: any) => {
  let total = 0;
  data?.map((item: any) => {
    total = total + (item.total_price ? parseFloat(item.total_price) : parseFloat(item.price));
  });
  return total;
};
